<template>
    <template
        v-for="block in pageBlocks"
        :key="block.canonicalUid"
    >
        <BlocksBlockWrapper
            v-if="block.__typename !== 'ds_SnippetBlock_Entry'"
            :block="block"
        />
        <template v-else>
            <!-- recursively call self -->
            <Blocks
                v-if="block.snippet_Content?.length"
                :snippet-blocks="block.snippet_Content[0].contentBuilder"
            />
        </template>
    </template>
</template>

<script setup>
    const { entry } = storeToRefs(useEntryStore())

    // props are only used for recursive rendering of snippet blocks
    const props = defineProps({
        snippetBlocks: {
            type: Array,
            default: undefined,
        },
    })

    const pageBlocks = computed(() => {
        return props.snippetBlocks ?? get(entry.value, 'contentBuilder', [])
    })
</script>
